<template>
  <main class="fixed-lte-page" role="main">
    <vue-loading :active.sync="isLoading" :can-cancel="false" :is-full-page="false"></vue-loading>
    <div class="wizard-container" v-if="!isLoading">
      <vue-good-wizard ref="wizard" :steps="dealSteps">
        <div slot="product-selector">
          <div class="lte-banner"  v-if="siteMode == 'customer'">
            <div class="banner">
              <div class="banner-header">
                <img
                  class="header-img"
                  src="/assets/images/banners/home/lte-banner-header.png"
                  alt="fixed-lte"
                />
              </div>
              <div class="text">
                <p>
                  Get reliable connectivity at your home or office with fixed LTE.
                </p>
                <p> Explore the better data experience of network-enhanced quality,</p>
                <p>Without the worry of a fixed line or contract.</p>
              </div>
              <img
                class="lte-features desktop"
                src="/assets/images/banners/home/MY220-Icon_element.png"
                alt="fixed-lte"
              />
              <img
                class="lte-features mobile"
                src="/assets/images/banners/home/lte-banner-bg-mobile.png"
                alt="fixed-lte"
              />
            </div>
          </div>
          <div class="info-grid sim-only"  v-if="siteMode == 'customer'">
            <h3 class="grid-title">
              Fixed
              <span>lte</span> sim only packages
            </h3>
            <div class="row">
              <div class="col">
                <img class="bundle-img" src="/assets/images/clipart/sim.png" />
                <p class="bundle-text">
                  <span class="data value">20</span>
                  <span class="data type">Gb</span>
                  <br />R149
                </p>
              </div>
              <div class="col">
                <img class="bundle-img" src="/assets/images/clipart/sim.png" />
                <p class="bundle-text">
                  <span class="data value">40</span>
                  <span class="data type">Gb</span>
                  <br />R199
                </p>
              </div>
              <div class="col">
                <img class="bundle-img" src="/assets/images/clipart/sim.png" />
                <p class="bundle-text">
                  <span class="data value">60</span>
                  <span class="data type">Gb</span>
                  <br />R299
                </p>
              </div>
              <div class="col">
                <img class="bundle-img" src="/assets/images/clipart/sim.png" />
                <p class="bundle-text">
                  <span class="data value">80</span>
                  <span class="data type">Gb</span>
                  <br />R399
                </p>
              </div>
              <div class="col">
                <img class="bundle-img" src="/assets/images/clipart/sim.png" />
                <p class="bundle-text left">
                  <span class="data value">100</span>
                  <span class="data type">Gb</span>
                  <br />R499
                </p>
              </div>
            </div>
          </div>
          <div class="info-grid top-up-info"  v-if="siteMode == 'customer'">            
            <h3 class="grid-title">
              Fixed
              <span class="top-up">lte</span> top-up bundles
            </h3>
            <div class="container">
              <div class="row">
                <div class="col">
                  <p class="bundle-text border-text">
                    <span class="data value">1</span>
                    <span class="data type">Gb</span>
                    <br />R10
                  </p>
                </div>
                <div class="col">
                  <p class="bundle-text border-text">
                    <span class="data value">2</span>
                    <span class="data type">Gb</span>
                    <br />R18
                  </p>
                </div>
                <div class="col">
                  <p class="bundle-text border-text">
                    <span class="data value">5</span>
                    <span class="data type">Gb</span>
                    <br />R45
                  </p>
                </div>
                <div class="col">
                  <p class="bundle-text">
                    <span class="data value">10</span>
                    <span class="data type">Gb</span>
                    <br />R69
                  </p>
                </div>
                <div class="col">
                  <p class="bundle-text border-text">
                    <span class="data value">25</span>
                    <span class="data type">Gb</span>
                    <br />R149
                  </p>
                </div>
                <div class="col">
                  <p class="bundle-text border-text">
                    <span class="data value">50</span>
                    <span class="data type">Gb</span>
                    <br />R299
                  </p>
                </div>
                <div class="col">
                  <p class="bundle-text">
                    <span class="data value">100</span>
                    <span class="data type">Gb</span>
                    <br />R599
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="lets-get-strated">
            <img src="/assets/images/clipart/Arrow_down.jpg">
             <h4 class="text">Let's get started</h4>
             <img src="/assets/images/clipart/Arrow_down.jpg">
             <!-- <img class="" src="/assets/images/clipart/Arrow_down.jpg" />-->
            
          </div>
          <product-selector :builder="builder" :product_type="'fixed-lte'"></product-selector>
        </div>
        <div slot="subscriber-details">
          <subscriber-details :builder="builder" :allowAnother="allowAnother"></subscriber-details>
        </div>
      </vue-good-wizard>
    </div>
  </main>
</template>

<script>
import SimModel from "@/models/sim.model.js";
import { GoodWizard } from "vue-good-wizard";
import Selector from "./selector.vue";
import SubscriberDetails from "./subscriber-details.vue";

import EventBus from "@/components/shared/event-bus";
import store from "@/store";
import { mapGetters } from "vuex";

import {
  CART_UPDATE_SUBSCRIBER,
  CART_ADD_ITEM,
  CART_RESET_CURRENT_ITEM,
  CART_UPDATE_CURRENT_ITEM,
  CART_UPDATE_CURRENT_STEP
} from "@/store/actions.type";

export default {
  name: "fixed-lte",
  components: {
    "vue-good-wizard": GoodWizard,
    "product-selector": Selector,
    "subscriber-details": SubscriberDetails
  },
  data() {
    return {
      is_loading: true,
      builder: false,
      allowAnother: false,
      dealSteps: [
        {
          slot: "product-selector"
        },
        {
          slot: "subscriber-details"
        }
      ],
      currentPage: store.state.cart.current_step
    };
  },
  computed: {
    ...mapGetters(["subscriberPlace", 'siteMode']),
    isLoading() {
      return store.state.products.is_loading;
    }
  },
  beforeMount() {
    var self = this;
    self.builder = self.$attrs.builder;
    self.registerListeners();
  },
  mounted() {
    var self = this;
    self.builder = self.$attrs.builder;
    store.dispatch(CART_RESET_CURRENT_ITEM);
    self.goToStep(store.state.cart.current_step);

    var selected_deal = self.$route.params.deal;
    if (
      typeof selected_deal != "undefined" &&
      selected_deal != "" &&
      selected_deal
    ) {
      self.allowAnother = false;
    }
  },
  methods: {
    setIccid(iccid) {
      var sim = new SimModel();
      sim.iccid = iccid;
      store.dispatch(CART_UPDATE_CURRENT_ITEM, sim);
      store.dispatch(CART_UPDATE_CURRENT_STEP, 0);
    },
    addSim(sim, step) {
      store.dispatch(CART_ADD_ITEM, sim);
      store.dispatch(CART_RESET_CURRENT_ITEM);
      store.dispatch(CART_UPDATE_CURRENT_STEP, step);
    },
    goNext() {
      var self = this;
      store.dispatch(CART_UPDATE_CURRENT_STEP, self.currentPage);
      self.$refs.wizard.goNext(true);
    },
    goBack() {
      var self = this;
      store.dispatch(CART_UPDATE_CURRENT_STEP, self.currentPage);
      self.$refs.wizard.goBack(true);
    },
    goToStep(step) {
      var self = this;
      store.dispatch(CART_UPDATE_CURRENT_STEP, step);
      self.$refs.wizard.goTo(step);
    },
    registerListeners() {
      var self = this;
      EventBus.$on("next-step", function(state) {
        self.$log.debug("THIS IS THE STATE", state);
        if (state == true && self.goNext(true)) {
          self.currentPage++;
        }
      });
      EventBus.$on("checkout", function(sim) {
        if (sim) {
          self.currentPage++;
          self.addSim(sim, self.currentPage);
          self.$router.push({ name: "checkout" });
        }
      });
      EventBus.$on("add-another-sim", function(sim) {
        if (sim) {
          self.addSim(sim, 0);
          self.goBack(true);
        }
      });
      EventBus.$on("back-step", function(s) {
        if (s.state && self.currentPage > 0) {
          self.currentPage--;
          self.goBack(true);
        }
      });
      EventBus.$on("subscriber-updated", function(value) {
        self.$log.debug("Subscriber Updating");
        store.dispatch(CART_UPDATE_SUBSCRIBER, value);
      });
    }
  }
};
</script>